/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as DataRouteImport } from './routes/data'
import { Route as EditorsRouteImport } from './routes/editors'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as QuestionnaireRouteImport } from './routes/questionnaire'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RfpReviewRouteImport } from './routes/rfp-review'
import { Route as SsoRouteImport } from './routes/sso'
import { Route as AdminConstitutionRouteImport } from './routes/admin.constitution'
import { Route as AdminInsightsRouteImport } from './routes/admin.insights'
import { Route as AdminKnowledgePacksRouteImport } from './routes/admin.knowledge-packs'
import { Route as AdminMemoryRouteImport } from './routes/admin.memory'
import { Route as AdminPersonasRouteImport } from './routes/admin.personas'
import { Route as AdminReliabilityRouteImport } from './routes/admin.reliability'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSkillsRouteImport } from './routes/admin.skills'
import { Route as AppsIndexRouteImport } from './routes/apps.index'
import { Route as AppsAppIdRouteImport } from './routes/apps.$appId'
import { Route as AppsDemoRouteImport } from './routes/apps.demo'
import { Route as AppsDemoReactRouteImport } from './routes/apps.demo-react'
import { Route as AppsNewRouteImport } from './routes/apps.new'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as DecksDeckIdRouteImport } from './routes/decks.$deckId'
import { Route as DesignIndexRouteImport } from './routes/design.index'
import { Route as DesignDesignIdRouteImport } from './routes/design.$designId'
import { Route as DesignNewRouteImport } from './routes/design.new'
import { Route as ImagesSessionIdRouteImport } from './routes/images.$sessionId'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as SettingsMemoryRouteImport } from './routes/settings.memory'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as TextSessionIdRouteImport } from './routes/text.$sessionId'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs.index'
import { Route as AuthenticatedJobsRunIdRouteImport } from './routes/_authenticated/jobs.$runId'
import { Route as DesignSystemsIndexRouteImport } from './routes/design.systems.index'
import { Route as DesignSystemsSystemIdRouteImport } from './routes/design.systems.$systemId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const DataRoute = DataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorsRoute = EditorsRouteImport.update({
  id: '/editors',
  path: '/editors',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionnaireRoute = QuestionnaireRouteImport.update({
  id: '/questionnaire',
  path: '/questionnaire',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RfpReviewRoute = RfpReviewRouteImport.update({
  id: '/rfp-review',
  path: '/rfp-review',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoRoute = SsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminConstitutionRoute = AdminConstitutionRouteImport.update({
  id: '/admin/constitution',
  path: '/admin/constitution',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInsightsRoute = AdminInsightsRouteImport.update({
  id: '/admin/insights',
  path: '/admin/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKnowledgePacksRoute = AdminKnowledgePacksRouteImport.update({
  id: '/admin/knowledge-packs',
  path: '/admin/knowledge-packs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMemoryRoute = AdminMemoryRouteImport.update({
  id: '/admin/memory',
  path: '/admin/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPersonasRoute = AdminPersonasRouteImport.update({
  id: '/admin/personas',
  path: '/admin/personas',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReliabilityRoute = AdminReliabilityRouteImport.update({
  id: '/admin/reliability',
  path: '/admin/reliability',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSkillsRoute = AdminSkillsRouteImport.update({
  id: '/admin/skills',
  path: '/admin/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdRoute = AppsAppIdRouteImport.update({
  id: '/apps/$appId',
  path: '/apps/$appId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsDemoRoute = AppsDemoRouteImport.update({
  id: '/apps/demo',
  path: '/apps/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsDemoReactRoute = AppsDemoReactRouteImport.update({
  id: '/apps/demo-react',
  path: '/apps/demo-react',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsNewRoute = AppsNewRouteImport.update({
  id: '/apps/new',
  path: '/apps/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DecksDeckIdRoute = DecksDeckIdRouteImport.update({
  id: '/decks/$deckId',
  path: '/decks/$deckId',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignIndexRoute = DesignIndexRouteImport.update({
  id: '/design/',
  path: '/design/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignDesignIdRoute = DesignDesignIdRouteImport.update({
  id: '/design/$designId',
  path: '/design/$designId',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignNewRoute = DesignNewRouteImport.update({
  id: '/design/new',
  path: '/design/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ImagesSessionIdRoute = ImagesSessionIdRouteImport.update({
  id: '/images/$sessionId',
  path: '/images/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMemoryRoute = SettingsMemoryRouteImport.update({
  id: '/settings/memory',
  path: '/settings/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TextSessionIdRoute = TextSessionIdRouteImport.update({
  id: '/text/$sessionId',
  path: '/text/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedJobsRunIdRoute = AuthenticatedJobsRunIdRouteImport.update({
  id: '/jobs/$runId',
  path: '/jobs/$runId',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const DesignSystemsIndexRoute = DesignSystemsIndexRouteImport.update({
  id: '/design/systems/',
  path: '/design/systems/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemsSystemIdRoute = DesignSystemsSystemIdRouteImport.update({
  id: '/design/systems/$systemId',
  path: '/design/systems/$systemId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/chat': typeof ChatRoute
  '/data': typeof DataRoute
  '/editors': typeof EditorsRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/questionnaire': typeof QuestionnaireRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rfp-review': typeof RfpReviewRoute
  '/sso': typeof SsoRoute
  '/admin/constitution': typeof AdminConstitutionRoute
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/knowledge-packs': typeof AdminKnowledgePacksRoute
  '/admin/memory': typeof AdminMemoryRoute
  '/admin/personas': typeof AdminPersonasRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/apps/$appId': typeof AppsAppIdRoute
  '/apps/demo': typeof AppsDemoRoute
  '/apps/demo-react': typeof AppsDemoReactRoute
  '/apps/new': typeof AppsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/decks/$deckId': typeof DecksDeckIdRoute
  '/design/$designId': typeof DesignDesignIdRoute
  '/design/new': typeof DesignNewRoute
  '/images/$sessionId': typeof ImagesSessionIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/share/$token': typeof ShareTokenRoute
  '/text/$sessionId': typeof TextSessionIdRoute
  '/apps/': typeof AppsIndexRoute
  '/design/': typeof DesignIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/jobs/$runId': typeof AuthenticatedJobsRunIdRoute
  '/design/systems/$systemId': typeof DesignSystemsSystemIdRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/design/systems/': typeof DesignSystemsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/chat': typeof ChatRoute
  '/data': typeof DataRoute
  '/editors': typeof EditorsRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/questionnaire': typeof QuestionnaireRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rfp-review': typeof RfpReviewRoute
  '/sso': typeof SsoRoute
  '/admin/constitution': typeof AdminConstitutionRoute
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/knowledge-packs': typeof AdminKnowledgePacksRoute
  '/admin/memory': typeof AdminMemoryRoute
  '/admin/personas': typeof AdminPersonasRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/apps/$appId': typeof AppsAppIdRoute
  '/apps/demo': typeof AppsDemoRoute
  '/apps/demo-react': typeof AppsDemoReactRoute
  '/apps/new': typeof AppsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/decks/$deckId': typeof DecksDeckIdRoute
  '/design/$designId': typeof DesignDesignIdRoute
  '/design/new': typeof DesignNewRoute
  '/images/$sessionId': typeof ImagesSessionIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/share/$token': typeof ShareTokenRoute
  '/text/$sessionId': typeof TextSessionIdRoute
  '/apps': typeof AppsIndexRoute
  '/design': typeof DesignIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/jobs/$runId': typeof AuthenticatedJobsRunIdRoute
  '/design/systems/$systemId': typeof DesignSystemsSystemIdRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/design/systems': typeof DesignSystemsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/chat': typeof ChatRoute
  '/data': typeof DataRoute
  '/editors': typeof EditorsRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/questionnaire': typeof QuestionnaireRoute
  '/reset-password': typeof ResetPasswordRoute
  '/rfp-review': typeof RfpReviewRoute
  '/sso': typeof SsoRoute
  '/admin/constitution': typeof AdminConstitutionRoute
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/knowledge-packs': typeof AdminKnowledgePacksRoute
  '/admin/memory': typeof AdminMemoryRoute
  '/admin/personas': typeof AdminPersonasRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/apps/$appId': typeof AppsAppIdRoute
  '/apps/demo': typeof AppsDemoRoute
  '/apps/demo-react': typeof AppsDemoReactRoute
  '/apps/new': typeof AppsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/decks/$deckId': typeof DecksDeckIdRoute
  '/design/$designId': typeof DesignDesignIdRoute
  '/design/new': typeof DesignNewRoute
  '/images/$sessionId': typeof ImagesSessionIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/settings/memory': typeof SettingsMemoryRoute
  '/share/$token': typeof ShareTokenRoute
  '/text/$sessionId': typeof TextSessionIdRoute
  '/apps/': typeof AppsIndexRoute
  '/design/': typeof DesignIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/_authenticated/jobs/$runId': typeof AuthenticatedJobsRunIdRoute
  '/design/systems/$systemId': typeof DesignSystemsSystemIdRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/design/systems/': typeof DesignSystemsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chat'
    | '/data'
    | '/editors'
    | '/feed'
    | '/login'
    | '/questionnaire'
    | '/reset-password'
    | '/rfp-review'
    | '/sso'
    | '/admin/constitution'
    | '/admin/insights'
    | '/admin/knowledge-packs'
    | '/admin/memory'
    | '/admin/personas'
    | '/admin/reliability'
    | '/admin/settings'
    | '/admin/skills'
    | '/apps/$appId'
    | '/apps/demo'
    | '/apps/demo-react'
    | '/apps/new'
    | '/auth/callback'
    | '/decks/$deckId'
    | '/design/$designId'
    | '/design/new'
    | '/images/$sessionId'
    | '/projects/$projectId'
    | '/settings/memory'
    | '/share/$token'
    | '/text/$sessionId'
    | '/apps/'
    | '/design/'
    | '/projects/'
    | '/jobs/$runId'
    | '/design/systems/$systemId'
    | '/jobs/'
    | '/design/systems/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chat'
    | '/data'
    | '/editors'
    | '/feed'
    | '/login'
    | '/questionnaire'
    | '/reset-password'
    | '/rfp-review'
    | '/sso'
    | '/admin/constitution'
    | '/admin/insights'
    | '/admin/knowledge-packs'
    | '/admin/memory'
    | '/admin/personas'
    | '/admin/reliability'
    | '/admin/settings'
    | '/admin/skills'
    | '/apps/$appId'
    | '/apps/demo'
    | '/apps/demo-react'
    | '/apps/new'
    | '/auth/callback'
    | '/decks/$deckId'
    | '/design/$designId'
    | '/design/new'
    | '/images/$sessionId'
    | '/projects/$projectId'
    | '/settings/memory'
    | '/share/$token'
    | '/text/$sessionId'
    | '/apps'
    | '/design'
    | '/projects'
    | '/jobs/$runId'
    | '/design/systems/$systemId'
    | '/jobs'
    | '/design/systems'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/chat'
    | '/data'
    | '/editors'
    | '/feed'
    | '/login'
    | '/questionnaire'
    | '/reset-password'
    | '/rfp-review'
    | '/sso'
    | '/admin/constitution'
    | '/admin/insights'
    | '/admin/knowledge-packs'
    | '/admin/memory'
    | '/admin/personas'
    | '/admin/reliability'
    | '/admin/settings'
    | '/admin/skills'
    | '/apps/$appId'
    | '/apps/demo'
    | '/apps/demo-react'
    | '/apps/new'
    | '/auth/callback'
    | '/decks/$deckId'
    | '/design/$designId'
    | '/design/new'
    | '/images/$sessionId'
    | '/projects/$projectId'
    | '/settings/memory'
    | '/share/$token'
    | '/text/$sessionId'
    | '/apps/'
    | '/design/'
    | '/projects/'
    | '/_authenticated/jobs/$runId'
    | '/design/systems/$systemId'
    | '/_authenticated/jobs/'
    | '/design/systems/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ChatRoute: typeof ChatRoute
  DataRoute: typeof DataRoute
  EditorsRoute: typeof EditorsRoute
  FeedRoute: typeof FeedRoute
  LoginRoute: typeof LoginRoute
  QuestionnaireRoute: typeof QuestionnaireRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RfpReviewRoute: typeof RfpReviewRoute
  SsoRoute: typeof SsoRoute
  AdminConstitutionRoute: typeof AdminConstitutionRoute
  AdminInsightsRoute: typeof AdminInsightsRoute
  AdminKnowledgePacksRoute: typeof AdminKnowledgePacksRoute
  AdminMemoryRoute: typeof AdminMemoryRoute
  AdminPersonasRoute: typeof AdminPersonasRoute
  AdminReliabilityRoute: typeof AdminReliabilityRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSkillsRoute: typeof AdminSkillsRoute
  AppsAppIdRoute: typeof AppsAppIdRoute
  AppsDemoRoute: typeof AppsDemoRoute
  AppsDemoReactRoute: typeof AppsDemoReactRoute
  AppsNewRoute: typeof AppsNewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  DecksDeckIdRoute: typeof DecksDeckIdRoute
  DesignDesignIdRoute: typeof DesignDesignIdRoute
  DesignNewRoute: typeof DesignNewRoute
  ImagesSessionIdRoute: typeof ImagesSessionIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  SettingsMemoryRoute: typeof SettingsMemoryRoute
  ShareTokenRoute: typeof ShareTokenRoute
  TextSessionIdRoute: typeof TextSessionIdRoute
  AppsIndexRoute: typeof AppsIndexRoute
  DesignIndexRoute: typeof DesignIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  DesignSystemsSystemIdRoute: typeof DesignSystemsSystemIdRoute
  DesignSystemsIndexRoute: typeof DesignSystemsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data': {
      id: '/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof DataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editors': {
      id: '/editors'
      path: '/editors'
      fullPath: '/editors'
      preLoaderRoute: typeof EditorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questionnaire': {
      id: '/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof QuestionnaireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfp-review': {
      id: '/rfp-review'
      path: '/rfp-review'
      fullPath: '/rfp-review'
      preLoaderRoute: typeof RfpReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/constitution': {
      id: '/admin/constitution'
      path: '/admin/constitution'
      fullPath: '/admin/constitution'
      preLoaderRoute: typeof AdminConstitutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/insights': {
      id: '/admin/insights'
      path: '/admin/insights'
      fullPath: '/admin/insights'
      preLoaderRoute: typeof AdminInsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/knowledge-packs': {
      id: '/admin/knowledge-packs'
      path: '/admin/knowledge-packs'
      fullPath: '/admin/knowledge-packs'
      preLoaderRoute: typeof AdminKnowledgePacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/memory': {
      id: '/admin/memory'
      path: '/admin/memory'
      fullPath: '/admin/memory'
      preLoaderRoute: typeof AdminMemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/personas': {
      id: '/admin/personas'
      path: '/admin/personas'
      fullPath: '/admin/personas'
      preLoaderRoute: typeof AdminPersonasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reliability': {
      id: '/admin/reliability'
      path: '/admin/reliability'
      fullPath: '/admin/reliability'
      preLoaderRoute: typeof AdminReliabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/skills': {
      id: '/admin/skills'
      path: '/admin/skills'
      fullPath: '/admin/skills'
      preLoaderRoute: typeof AdminSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId': {
      id: '/apps/$appId'
      path: '/apps/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AppsAppIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/demo': {
      id: '/apps/demo'
      path: '/apps/demo'
      fullPath: '/apps/demo'
      preLoaderRoute: typeof AppsDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/demo-react': {
      id: '/apps/demo-react'
      path: '/apps/demo-react'
      fullPath: '/apps/demo-react'
      preLoaderRoute: typeof AppsDemoReactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/new': {
      id: '/apps/new'
      path: '/apps/new'
      fullPath: '/apps/new'
      preLoaderRoute: typeof AppsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decks/$deckId': {
      id: '/decks/$deckId'
      path: '/decks/$deckId'
      fullPath: '/decks/$deckId'
      preLoaderRoute: typeof DecksDeckIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design/': {
      id: '/design/'
      path: '/design'
      fullPath: '/design/'
      preLoaderRoute: typeof DesignIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design/$designId': {
      id: '/design/$designId'
      path: '/design/$designId'
      fullPath: '/design/$designId'
      preLoaderRoute: typeof DesignDesignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design/new': {
      id: '/design/new'
      path: '/design/new'
      fullPath: '/design/new'
      preLoaderRoute: typeof DesignNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/images/$sessionId': {
      id: '/images/$sessionId'
      path: '/images/$sessionId'
      fullPath: '/images/$sessionId'
      preLoaderRoute: typeof ImagesSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/memory': {
      id: '/settings/memory'
      path: '/settings/memory'
      fullPath: '/settings/memory'
      preLoaderRoute: typeof SettingsMemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/text/$sessionId': {
      id: '/text/$sessionId'
      path: '/text/$sessionId'
      fullPath: '/text/$sessionId'
      preLoaderRoute: typeof TextSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$runId': {
      id: '/_authenticated/jobs/$runId'
      path: '/jobs/$runId'
      fullPath: '/jobs/$runId'
      preLoaderRoute: typeof AuthenticatedJobsRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/design/systems/': {
      id: '/design/systems/'
      path: '/design/systems'
      fullPath: '/design/systems/'
      preLoaderRoute: typeof DesignSystemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design/systems/$systemId': {
      id: '/design/systems/$systemId'
      path: '/design/systems/$systemId'
      fullPath: '/design/systems/$systemId'
      preLoaderRoute: typeof DesignSystemsSystemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedJobsRunIdRoute: typeof AuthenticatedJobsRunIdRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedJobsRunIdRoute: AuthenticatedJobsRunIdRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ChatRoute: ChatRoute,
  DataRoute: DataRoute,
  EditorsRoute: EditorsRoute,
  FeedRoute: FeedRoute,
  LoginRoute: LoginRoute,
  QuestionnaireRoute: QuestionnaireRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RfpReviewRoute: RfpReviewRoute,
  SsoRoute: SsoRoute,
  AdminConstitutionRoute: AdminConstitutionRoute,
  AdminInsightsRoute: AdminInsightsRoute,
  AdminKnowledgePacksRoute: AdminKnowledgePacksRoute,
  AdminMemoryRoute: AdminMemoryRoute,
  AdminPersonasRoute: AdminPersonasRoute,
  AdminReliabilityRoute: AdminReliabilityRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSkillsRoute: AdminSkillsRoute,
  AppsAppIdRoute: AppsAppIdRoute,
  AppsDemoRoute: AppsDemoRoute,
  AppsDemoReactRoute: AppsDemoReactRoute,
  AppsNewRoute: AppsNewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  DecksDeckIdRoute: DecksDeckIdRoute,
  DesignDesignIdRoute: DesignDesignIdRoute,
  DesignNewRoute: DesignNewRoute,
  ImagesSessionIdRoute: ImagesSessionIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  SettingsMemoryRoute: SettingsMemoryRoute,
  ShareTokenRoute: ShareTokenRoute,
  TextSessionIdRoute: TextSessionIdRoute,
  AppsIndexRoute: AppsIndexRoute,
  DesignIndexRoute: DesignIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  DesignSystemsSystemIdRoute: DesignSystemsSystemIdRoute,
  DesignSystemsIndexRoute: DesignSystemsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
